export const InternalServerErrorMessage =
  'Oops! Internal server error Please try refreshing the page. If the issue persists, please reach out to us at support@acko.com';

export const PRODUCTION_ENVIRONMENT =
  process.env.NEXT_PUBLIC_ENVIRONMENT !== 'master' &&
  process.env.NEXT_PUBLIC_ENVIRONMENT !== 'dev';
